import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import { jsx } from 'react/jsx-runtime';
import { Text, theme, TextLink } from '@dls/web';
import styled, { css } from 'styled-components';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const SCText = styled(Text)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.1s ease-in;\n  &:hover,\n  &:active {\n    color: ", ";\n  }\n  ", "\n  span {\n    padding-right: 8px;\n    line-height: 0;\n  }\n  span:last-of-type {\n    padding: 0;\n  }\n"])), theme.main.colours.secondary.d3, props => props.inline && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-size: inherit;\n    "]))));
const BaseLink = _a => {
  var _b = _a,
    {
      component: Component,
      inline,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["component", "inline", "children", "className"]);
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({}, rest), {
    className: "text-decoration-none ".concat(className || ""),
    children: /* @__PURE__ */jsx(SCText, {
      type: "link",
      tag: "span",
      inline,
      children
    })
  }));
};
BaseLink.Icon = TextLink.Icon;
BaseLink.Text = TextLink.Text;
export { BaseLink as default };